import {GlowType} from '@PosterWhiteboard/poster/poster-backend.types';

export interface GlowEffectOptionsData {
  effect: GlowType;
  thumbnail: string;
}

export const GlowEffectOptionsDataArray: GlowEffectOptionsData[] = [
  {
    effect: GlowType.NONE,
    thumbnail: 'none',
  },
  {
    effect: GlowType.LIGHT,
    thumbnail: 'light',
  },
  {
    effect: GlowType.STRONG,
    thumbnail: 'strong',
  },
];
